import moment from 'moment';
import React, { useEffect, useState } from 'react';
import NumberFormat from 'react-number-format';
import { subscribeListener, unsubscribeListener } from 'redux/ably/sagas';
import { colors, styled } from '../../../assets/theme';

interface IPasts {
  model?: string
  watch?: number
  action?: 'BUY' | 'SELL'
  start_time?: number
  end_time?: number
  price?: number
  pmax?: number
  tgt?: number
}

const CompleteRotationalModelTrade: React.FunctionComponent<{past: IPasts}> = ({ past }) => {
  const [modelpts, setModelpts] = useState<number>()
  const [symbol, setSymbol] = useState<string>()
  useEffect(() => {
    if (past && past.model) {
      setModelpts(+(past.model.split('_static')[1].replace('_', '.')))
      setSymbol(past.model.split('_')[0].toUpperCase())
    }
  }, [past])
  return (
    <ModelTradeContainer>
      <div>
        {
          symbol === 'ZB' ?
          <div>{modelpts}{symbol} ticks @<NumberFormat value={past.watch} displayType="text" fixedDecimalScale={true} decimalScale={1} />%</div>
          :
          <div>{modelpts} pt @<NumberFormat value={past.watch} displayType="text" fixedDecimalScale={true} decimalScale={1} />%</div>
        }
        <div><span>{past.action}</span><span>{symbol}</span></div>
      </div>
      <div>
        <div>START:</div>
        <div>STOP:</div>
      </div>
      <div>
        <div>{moment(past.start_time).format('YYYY-MM-DD HH:mm:ss')}</div>
        <div>{moment(past.end_time).format('YYYY-MM-DD HH:mm:ss')}</div>
      </div>
      <DataItem>
        <div>Price @Max</div>
        <div><NumberFormat value={past.price} displayType="text" fixedDecimalScale={true} decimalScale={symbol === 'ZB' ? 0: 2 } /></div>
      </DataItem>
      <DataItem>
        <div>pMax</div>
        <div><NumberFormat value={past.pmax} displayType="text" fixedDecimalScale={true} decimalScale={2} />%</div>
      </DataItem>
      <DataItem>
        <div>Target</div>
        <div><NumberFormat value={past.tgt} displayType="text" fixedDecimalScale={true} decimalScale={symbol === 'ZB' ? 0 : 2} /></div>
      </DataItem>
    </ModelTradeContainer>
  );
};

export const CompleteRotationalModelTrades: React.FunctionComponent<{id: number}> = ({ id }) => {
  const [pasts, setPasts] = useState<{ [key: string]: IPasts}>({});

  useEffect(() => {
    subscribeListener('rotations:pasts', id, ({ data }) => {
      setPasts(data);
    });
    return () => {
      unsubscribeListener('rotations:pasts', id);
    };
  }, [id]);

  if (Object.keys(pasts).length === 0) { return <div />; }
  return (
    <ModelTradesContainer>
      {
        Object.keys(pasts)
        .map(past => <CompleteRotationalModelTrade key={past} past={pasts[past]} />)
      }
    </ModelTradesContainer>
  );
};

const DataItem = styled.div`
  display: grid;
  justify-items: center;
> :first-child {
  color: ${({ theme }) => theme.core.textColor};
  font-size: smaller;
}
`;

const ModelTradesContainer = styled.div`
  color: ${colors.accents.dominant.base};
  border: solid 1px ${({ theme }) => theme.core.offBackground};
  > :nth-child(2n+1) {
    background: ${({ theme }) => theme.core.alternateBackground};
  }
`;

const ModelTradeContainer = styled.div`
  padding: 0.5em;
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: repeat(6, 1fr);

> :first-child {
  font-size: larger;
  display: grid;
  grid-auto-flow: row;
  grid-gap: 0.5em;

  > :last-child {
    font-weight: 600;
    font-size: larger;
    display: grid;
    grid-auto-flow: column;
    grid-gap: 1em;
    justify-content: start;
  }
}
`;
